import { gql } from '@apollo/client';

export const EMPLOYEE_ALL_FIELDS = gql`
  fragment EmployeeFields on Employee {
    id
    emp_id
    status
    first_name
    last_name
    date_of_joining
    date_of_relieving
    pan
    aadhar
    designation {
      id
      name
      code
    }
    portfolio {
      id
      name
      code
    }
    productType {
      id
      name
      code
    }
    stage {
      id
      name
      code
    }
    identityCard {
      id
      card_number
      card_validity_end
      dra_number
      dra_training_start
      dra_training_end
      pvc_number
      pvc_validity_end
      rac_mobility_id
      cc_mobility_id
      did_number
    }
    healthInsurance {
      id
      provider
      policy_start_date
      policy_end_date
      type
      sum_insured
    }
    location {
      id
      name
      region {
        id
        name
      }
    }
    contact {
      id
      email
      phone_1
      phone_2
      address_1
      address_2
      city
      state
      pin_code
      reference_name
      reference_contact
    }
    bankInfo {
      id
      bank_name
      branch
      account_number
      ifsc_code
    }
    documents {
      id
      type
      description
      created_by {
        id
        name
      }
      created_at
      media {
        id
        name
        file_name
      }
    }
  }
`;

export const EMPLOYEE_LIST_FIELDS = gql`
  fragment EmployeeListFields on Employee {
    id
    emp_id
    status
    first_name
    last_name
    date_of_joining
    designation {
      id
      name
    }
    portfolio {
      id
      name
      code
    }
    productType {
      id
      name
      code
    }
    stage {
      id
      name
      code
    }
    identityCard {
      id
      card_number
      card_validity_end
      dra_number
      dra_training_start
      dra_training_end
      dra_status
      pvc_number
      pvc_validity_end
      rac_mobility_id
      cc_mobility_id
      did_number
    }
    healthInsurance {
      id
      provider
      policy_start_date
      policy_end_date
      type
      sum_insured
    }
    location {
      id
      name
      region {
        id
        name
      }
    }
    contact {
      id
      phone_1
      phone_2
      email
    }
  }
`;

export const ADVANCES_LIST_FIELDS = gql`
  fragment AdvanceListFields on Advance {
    id
    for_month
    amount
    note
    employee_id
    employee {
      id
      emp_id
      first_name
      last_name
    }
    deductions {
      id
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const ADVANCE_DEDUCTIONS_LIST_FIELDS = gql`
  fragment AdvanceDeductionListFields on AdvanceDeduction {
    id
    for_month
    amount
    note
    advance_id
    advance {
      employee_id
      employee {
        id
        emp_id
        first_name
        last_name
      }
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const LEAVE_LIST_FIELDS = gql`
  fragment LeaveListFields on Leave {
    id
    date_from
    date_to
    note
    half_day
    days_calculated
    leave_type {
      id
      name
      code
    }
    employee {
      id
      emp_id
      first_name
      last_name
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const ALLOWANCE_LIST_FIELDS = gql`
  fragment AllowanceListFields on Allowance {
    id
    for_month
    amount
    note
    allowance_type {
      id
      name
      code
    }
    employee {
      id
      emp_id
      first_name
      last_name
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const DEDUCTION_LIST_FIELDS = gql`
  fragment DeductionListFields on Deduction {
    id
    for_month
    amount
    note
    deduction_type {
      id
      name
      code
    }
    employee {
      id
      emp_id
      first_name
      last_name
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const INCENTIVE_IMPORT_LIST_FIELDS = gql`
  fragment IncentiveImportsListFields on IncentiveImport {
    id
    for_month
    records_processed
    portfolio_id
    portfolio {
      id
      name
    }
    note
    media {
      id
      name
      file_name
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const INCENTIVE_LIST_FIELDS = gql`
  fragment IncentivesListFields on Incentive {
    id
    import_id
    portfolio_id
    portfolio {
      id
      name
    }
    stage_id
    stage {
      id
      name
    }
    product_type_id
    productType {
      id
      name
    }
    for_month
    bucket
    am_id
    am {
      id
      emp_id
    }
    tl_id
    tl {
      id
      emp_id
    }
    fe_id
    fe {
      id
      emp_id
    }
    tl_incentive
    fe_incentive
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const CONVEYANCES_LIST_FIELDS = gql`
  fragment ConveyanceListFields on Conveyance {
    id
    conveyance_type_id
    conveyance_type {
      id
      name
    }
    employee_id
    employee {
      id
      emp_id
      first_name
      last_name
    }
    effective_from
    amount
    note
    revisions {
      id
      conveyance_type_id
      conveyance_type {
        id
        name
      }
      employee_id
      employee {
        id
        emp_id
        first_name
        last_name
      }
      effective_from
      amount
      note
      createdBy {
        id
        name
      }
      created_at
    }
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const PAYSLIP_LIST_FIELDS = gql`
  fragment PayslipListFields on PayslipsResponseData {
    id
    employee_id
    emp_id
    first_name
    last_name
    location_id
    for_month
    conveyance
    fe_incentive_amount
    tl_incentive_amount
    allowance
    deduction
    note
    created_by
    createdBy
    created_at
  }
`;

export const PAYSLIP_ALL_FIELDS = gql`
  fragment PayslipAllFields on Payslip {
    id
    for_month
    leave_adjusted
    tax_percentage
    conveyance
    conveyanceAdjusted
    totalIncentive
    totalAllowance
    totalDeduction
    taxDeduction
    totalEarning
    netEarning
    balance_adjusted
    note
    employee {
      id
      emp_id
      designation {
        id
        code
        name
      }
      first_name
      last_name
      date_of_joining
    }
    location {
      id
      name
      region {
        id
        name
      }
    }
    incentives {
      id
      productType {
        id
        name
      }
      type
      amount
    }
    allowances {
      id
      amount
      allowanceType {
        id
        name
      }
    }
    deductions {
      id
      amount
      deductionType {
        id
        name
      }
    }
    created_by
    createdBy {
      id
      name
    }
    created_at
  }
`;

export const PAYMENT_LIST_FIELDS = gql`
  fragment PaymentListFields on Payment {
    id
    import_id
    employee_id
    employee {
      id
      emp_id
      first_name
      last_name
    }
    for_month
    amount
    created_at
    createdBy {
      id
      name
    }
  }
`;

export const REPORT_INCENTIVES_SUMMARY_FIELDS = gql`
  fragment IncnetivesSummaryReportFields on IncentivesReportData {
    id
    for_month
    location_id
    location_name
    portfolio_id
    portfolio_name
    am_id
    am_emp_code
    am_first_name
    am_last_name
    fe_incentive {
      name
      value
    }
    tl_incentive {
      name
      value
    }
  }
`;

export const REPORT_AGENCY_MANAGER_FIELDS = gql`
  fragment AgencyManagerReportFields on AGMReportData {
    id
    leave_adjusted
    am_id
    am_code
    am_first_name
    am_last_name
    employee_id
    emp_code
    first_name
    last_name
    designation_id
    designation_name
    employee_status
    location_id
    location_name
    basic
    conveyance
    balance_adjusted
    employee_id
    spl_allowance
    fe_incentive {
      name
      value
    }
    tl_incentive {
      name
      value
    }
    deductions {
      name
      value
    }
    gross_pay
    common_deduction
    net_pay
  }
`;
